import React from 'react';
import { Box, Flex } from 'components/ui';
import BaseButton from '../ui/Button/Button';
import EthSign from '../ui/EthSign';
import { siteDisabled } from 'utils/config';
import { SpaceProps, TypographyProps } from 'styled-system';

interface BurnPrintButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children?: any;
  price: string | number;
  ml?: string;
  width?: string;
  loading?: boolean;
}

const Button = ({ children, ...rest }: any) => {
  return (
    <BaseButton
      bg="transparent"
      borderRadius="10px"
      border="1px solid"
      borderColor="highlight"
      width="100%"
      boxShadow="1"
      maxWidth="300px"
      fontWeight="600"
      p="1em"
      color="copy"
      {...rest}
    >
      {children}
    </BaseButton>
  );
};

export const ApproveBurnButton = ({ ...rest }: any) => {
  return <Button {...rest}>🔓 Approve burn</Button>;
};

const BurnPrintButton = ({
  price,
  children,
  loading,
  ...rest
}: BurnPrintButtonProps & TypographyProps & SpaceProps) => {
  if (siteDisabled) {
    return null;
  }

  return (
    <Button {...rest}>
      <Flex justifyCenter>
        {loading ? (
          'Loading...'
        ) : rest.disabled ? (
          'Burning not yet enabled'
        ) : (
          <>
            <Box color="copy" mr="3">
              Burn Print
            </Box>
            <Box alignSelf="flex-end" color="copy">
              <EthSign value={price.toString()} />
            </Box>
          </>
        )}
      </Flex>
    </Button>
  );
};

export default BurnPrintButton;
